import React from "react";
import Tabla from "./Tabla";
import alert_icon from "../../../assets/vw/svg/notificaciones.svg";
import ARCH from "../../../assets/vw/svg/archivo.svg";
import Loading from "../../../components/Loading";
import Menu from "../../../components/Menu"
import TablaArchivo from "./TablaInactivos";
import Modal from "../../../components/Modal";
import NoInfoScreen from "../../../components/Screens/NoInfoScreen";


class NotificacionesUsuario extends React.Component {
  constructor(props) {
    super(props);
    this.state = {
      data: [],
      dataFiltradas: [],
      aplicaciones: [],
      canales: [],
      cargando: true,
      searchInput: "",
      option: "notificar",
      dataOriginal:[],
      inactivas:[],
      inactivasFiltradas:[],
      modal: {
        active: false,
        message: '',
        success: false
      },
      success: false
    };
  }

  componentDidMount() {
    Promise.all([
      fetch(process.env.REACT_APP_URL_DTO_BACK + "notificaciones?todos", {
        method: "GET",
        headers: {
          Authorization: "Bearer " + this.props.servicio.getToken(),
          "Content-Type": "application/json",
        },
      }).then(async (res) => {
        let response = await res.json();
        if (!res.ok) {
          throw new Error(response.mensaje);
        }
        return response;
      }),
      fetch(process.env.REACT_APP_URL_DTO_BACK + "aplicacion?todos", {
        method: "GET",
        headers: {
          Authorization: "Bearer " + this.props.servicio.getToken(),
          "Content-Type": "application/json",
        },
      }).then(async (res) => {
        let response = await res.json();
        if (!res.ok) {
          throw new Error(response.mensaje);
        }
        return response;
      }),
      fetch(process.env.REACT_APP_URL_DTO_BACK + "roles?rol=todos", {
        method: "GET",
        headers: {
          Authorization: "Bearer " + this.props.servicio.getToken(),
          "Content-Type": "application/json",
        },
      }).then(async (res) => {
        let response = await res.json();
        if (!res.ok) {
          throw new Error(response.mensaje);
        }
        return response;
      }),
      fetch(process.env.REACT_APP_URL_DTO_BACK + "canales", {
        method: "GET",
        headers: {
          "Content-Type": "application/json",
          Authorization: `Bearer ${this.props.servicio.getToken()}`,
        },
      }).then(async (res) => {
        let response = await res.json();
        if (!res.ok) {
          throw new Error(response.mensaje);
        }
        return response;
      }),
    ])
      .then(
        ([
          responseBodyAnuncios,
          responseBodyAplicaciones,
          responseBodyRoles,
          responseCanales,
        ]) => {
          const activas = responseBodyAnuncios.mensaje.filter((anuncio) => {
            return anuncio.activo === 1;
          });
          this.setState({
            cargando: false,
            dataOriginal: responseBodyAnuncios.mensaje,
            aplicaciones: responseBodyAplicaciones.mensaje,
            roles: responseBodyRoles.mensaje,
            canales: responseCanales.mensaje,
            data: activas,
            success: true
          });
        }
      )
      .catch((errorP) => {
        this.setState({ cargando: false, modal: {
          active: true,
          message: errorP.message,
          success: false
        },
        success: false 
      });
        console.error(errorP.stack || errorP);
      });
  }

  handleChange = (event) => {
    if (this.state.option === "archivo") {
      this.setState({ searchInput: event.target.value }, () => {
        this.globalSearchInactivas();
      });
    } else{
    this.setState({ searchInput: event.target.value }, () => {
      this.globalSearch();
    });}
  };

  globalSearch = () => {
    let { data, searchInput } = this.state;
    if (searchInput && searchInput !== "") {
      let dataFiltradas = data.filter((value) => {
        if (value.titulo) {
          return (
            value.accion.toLowerCase().includes(searchInput.toLowerCase()) ||
            value.remitente.toLowerCase().includes(searchInput.toLowerCase()) ||
            value.idAplicacion.toString().includes(searchInput.toLowerCase()) ||
            value.titulo.toLowerCase().includes(searchInput.toLowerCase())
          );
        } else {
          return (
            value.accion.toLowerCase().includes(searchInput.toLowerCase()) ||
            value.remitente.toLowerCase().includes(searchInput.toLowerCase()) ||
            value.idAplicacion.toString().includes(searchInput.toLowerCase())
          );
        }
      });
      this.setState({ dataFiltradas });
    } else {
      let dataFiltradas = [];
      this.setState({ dataFiltradas });
    }
  };

  globalSearchInactivas = () => {
    let { inactivas, searchInput } = this.state;
    if (searchInput && searchInput !== "") {
      let inactivasFiltradas = inactivas.filter((value) => {
        if (value.titulo) {
          return (
            value.accion.toLowerCase().includes(searchInput.toLowerCase()) ||
            value.remitente.toLowerCase().includes(searchInput.toLowerCase()) ||
            value.idAplicacion.toString().includes(searchInput.toLowerCase()) ||
            value.titulo.toLowerCase().includes(searchInput.toLowerCase())
          );
        } else {
          return (
            value.accion.toLowerCase().includes(searchInput.toLowerCase()) ||
            value.remitente.toLowerCase().includes(searchInput.toLowerCase()) ||
            value.idAplicacion.toString().includes(searchInput.toLowerCase())
          );
        }
      });
      this.setState({ inactivasFiltradas });
    } else {
      let inactivasFiltradas = [];
      this.setState({ inactivasFiltradas });
    }
  };

  changeOption = (option) => {
    this.setState({ inactivas:[], inactivasFiltradas:[], dataFiltradas: [] });
    this.setState({ option });
    if (option === "archivo") {
          this.notifiacionesInactivos(this.state.dataOriginal);
        }
  };

  notifiacionesInactivos = (data) => {
    const inactivas = data.filter((notificacion) => {
      return notificacion.activo === 0;
    });
    this.setState({ inactivas });
  };

  render() {
    return (
      <>
      <Menu/>
      <Modal 
        modalInfo={this.state.modal} 
        setMostrarModal={(data) => {
          this.setState({ modal: data });
        }} 
      />
      {
        this.state.cargando && <Loading />
      }
      <div className={`navegacion`}>
      {this.state.success ? (
          <>
            <div className=" posicionMenu">
              <ul className="d-flex flex-row px-0 my-0">
                <li
                  className="opcion-ruta"
                  onClick={() => this.changeOption("notificar")}
                >
                  <div
                    className={`nav-link nav-link-title active ps-0 ${
                      this.state.option === "notificar" ? " active border_menu" : ""
                    }`}
                  >
                    <img
                      src={alert_icon}
                      alt="rol"
                      className="icono-menu me-3"
                    />
                   Notificaciones
                  </div>
                </li>
                <li
                  className="opcion-ruta"
                  onClick={() => this.changeOption("archivo")}
                >
                  <div
                    className={`nav-link active ps-0  ${
                      this.state.option === "archivo"
                        ? " active border_menu"
                        : ""
                    }`}
                  >
                    <img src={ARCH} alt="archivo" className="icono-menu me-3" />
                    Archivo
                  </div>
                </li>
              </ul>
            </div>
            <div className="row border_vw pt-4 ms-0 mx-0">
              <div className="col-12 p-0 contenedor-table">
              {this.state.option === "archivo" ? (
                  <TablaArchivo
                  data={
                    this.state.inactivasFiltradas &&
                    this.state.inactivasFiltradas.length
                      ? this.state.inactivasFiltradas
                      : this.state.inactivas
                  }
                  canales={this.state.canales}
                  servicio={this.props.servicio}
                  acciones={this.state.acciones}
                  aplicaciones={this.state.aplicaciones}
                  handleChange={this.handleChange}
                  ></TablaArchivo>
                ) :  (
                  <Tabla
                    data={
                      this.state.dataFiltradas &&
                      this.state.dataFiltradas.length
                        ? this.state.dataFiltradas
                        : this.state.data
                    }
                    canales={this.state.canales}
                    servicio={this.props.servicio}
                    acciones={this.state.acciones}
                    aplicaciones={this.state.aplicaciones}
                    handleChange={this.handleChange}
                  ></Tabla>
                ) }
              </div>
            </div>
          </>
        ) : (
          <>
            {
              !this.state.cargando && <NoInfoScreen />
            }
          </>
        )
        
        }
      </div>
      </>
    );
  }
}

export default NotificacionesUsuario;
